var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#51247A;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("circle", {
    cx: 11.997,
    cy: 11.997,
    r: 1.112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.942,7.7l.327,1.076a.736.736,0,0,0,.869.505l1.092-.253a.992.992,0,0,1,.943,1.644l-.763.823a.743.743,0,0,0,0,1.01l.763.823a.992.992,0,0,1-.944,1.644l-1.091-.253a.736.736,0,0,0-.87.505L12.941,16.3a.986.986,0,0,1-1.889,0l-.327-1.077a.737.737,0,0,0-.87-.505l-1.091.253a.993.993,0,0,1-.945-1.644l.763-.823a.743.743,0,0,0,0-1.01l-.763-.823a.993.993,0,0,1,.946-1.644l1.094.253a.736.736,0,0,0,.87-.505L11.056,7.7a.987.987,0,0,1,1.886,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 1.75,
    r: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5.5,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.248,
    cy: 4.752,
    r: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.596,
    y1: 7.404,
    x2: 18.364,
    y2: 5.636
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.25,
    cy: 12,
    r: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 12,
    x2: 21,
    y2: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.248,
    cy: 19.248,
    r: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.596,
    y1: 16.596,
    x2: 18.364,
    y2: 18.364
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 22.25,
    r: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18.5,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.752,
    cy: 19.248,
    r: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.404,
    y1: 16.596,
    x2: 5.636,
    y2: 18.364
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.75,
    cy: 12,
    r: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 12,
    x2: 3,
    y2: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.752,
    cy: 4.752,
    r: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.404,
    y1: 7.404,
    x2: 5.636,
    y2: 5.636
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.415db74c.svg";
export { ForwardRef as ReactComponent };